import React from "react";

const PriceCalculator = ({ price }) => {
    const [number, decimal] = price.split(".");

    return (
        <div className="calculator">
            <div className="calculator__initial-text">Desde</div>
            <div className="calculator__price-container">
                <div className="calculator__price-container-currency">S/</div>
                <div className="calculator__price-container-amount">
                    <span className="calculator__price-container-amount-number">
                        {number}
                    </span>
                    <span className="calculator__price-container-amount-decimal">
                        .{decimal}
                    </span>
                </div>
                <div className="calculator__price-container-period">al mes</div>
            </div>
        </div>
    );
};

export default PriceCalculator;
